import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as $ from 'jquery'; window["$"] = $; window["jQuery"] = $;
if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));



// WEBPACK FOOTER //
// /mnt/volume_sfo2_01/www/html/anbe-dev/src/main.ts